import LikeCard from 'modules/notifications/likes/components/LikeCard/LikeCard'

export default LikeCard
